import { render } from "./DateAndTime.vue?vue&type=template&id=007b40a9"
import script from "./DateAndTime.vue?vue&type=script&lang=ts"
export * from "./DateAndTime.vue?vue&type=script&lang=ts"
script.render = render

export default script